<template>
  <div class="d-flex align-center column-gap-2">
    <app-material-icon v-if="!validation.validated"
      name="schedule"
      color="text-tertiary"
    />

    <AppTooltip v-if="validation.validated">
      <template #activator="{ props }">
        <app-material-icon
          name="check_circle"
          color="icon-success"
          v-bind="props"
        />
      </template>
      <span>
        {{
          $t(
              'project.project-settings.signatures.ProjectSettingsSignaturesValidator.validatedAtTooltip',
              { date: ISOToShortDate(validation.validator.validatedAt) },
          )
        }}
      </span>
    </AppTooltip>

    <div>{{ validation.validator.fullName }}</div>

    <app-button v-if="canChase()"
                :loading="isValidationChaseLoading()"
                :disabled="validationChaseButtonIsDisabled()"
                size="small"
                type="outlined"
                variant="neutral"
                class="ml-1"
                @click.stop="prepareChaseValidators"
    >
      {{ $t('common.chase') }}
    </app-button>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { ISOToShortDate } from '@/common/utils/dates'
import { toast } from '@/common/utils/toast'
import { CHASE_VALIDATOR } from '@/store/modules/room/action_types'
import { ADD_CHASE_TIMER_VALIDATION } from '@/store/modules/room/mutation_types'

export default {
  name: 'ProjectSettingsSignaturesValidator',
  components: { AppTooltip },
  props: {
    validation: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('room', ['chaseTimers', 'chaseValidatorPendingIds']),
    ...mapGetters('room', ['roomMnemo']),
  },
  methods: {
    ...mapActions('room', [CHASE_VALIDATOR]),
    ...mapMutations('room', [ADD_CHASE_TIMER_VALIDATION]),
    ISOToShortDate,
    isValidationChaseLoading () {
      return this.chaseValidatorPendingIds.includes(this.validation.id)
    },
    canChase () {
      return (this.item.status === 'unvalidated' || this.item.status === 'sent') && !this.validation.validated
    },
    validationChaseButtonIsDisabled () {
      const validationChaseTimer = this.chaseTimers.validation?.[this.validation.id]
      return validationChaseTimer && dayjs().isBefore(validationChaseTimer)
    },
    async prepareChaseValidators () {
      try {
        await this.CHASE_VALIDATOR({
          mnemo: this.roomMnemo,
          envelopeId: this.item.id,
          data: [this.validation.validator.id],
          validationId: this.validation.id,
        })
        toast.success(this.$t('common.chaseSuccess'))
        this.ADD_CHASE_TIMER_VALIDATION(this.validation.id)
      } catch (error) {
        toast.error(this.$t('common.chaseError'))
      }
    },
  },
}
</script>
